export const calculateRiskScore = (data) => {
  let score = 0;

  // Drawdown risk (largest factor)
  if (data.maxDrawdown >= 80) score += 6;
  else if (data.maxDrawdown >= 50) score += 4;
  else if (data.maxDrawdown >= 30) score += 3;
  else if (data.maxDrawdown >= 10) score += 2;
  else score += 1;

  // Sharpe ratio penalty
  if (data.sharpeRatio < 0.5) score += 3;
  else if (data.sharpeRatio < 1) score += 2;
  else if (data.sharpeRatio < 2) score += 1;

  // Volatility risk
  if (data.downsideDeviation > 50) score += 2;
  else if (data.downsideDeviation > 20) score += 1;

  // Cap score at 10
  return Math.min(score, 10);
};

const CURRENCY_SYMBOL_MAP = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
};

const getCurrencyDisplayValue = (currency) => {
  if (!currency) return "";
  return CURRENCY_SYMBOL_MAP[currency] || currency;
};

export const formatSocialTradingCurrency = (
  value,
  currency = "USD",
  {
    minimumFractionDigits = 0,
    maximumFractionDigits,
    fallback = "-",
    fallbackToRawOnInvalid = false,
  } = {},
) => {
  if (value === undefined || value === null || value === "") return fallback;

  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    if (!fallbackToRawOnInvalid) return fallback;
    const symbolOrCode = getCurrencyDisplayValue(currency);
    return symbolOrCode ? `${symbolOrCode} ${value}` : String(value);
  }

  const symbolOrCode = getCurrencyDisplayValue(currency);
  const minDigits = minimumFractionDigits;
  const maxDigits = Math.max(minDigits, maximumFractionDigits ?? minDigits);
  const formattedAmount = numeric.toLocaleString("en-US", {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });

  return symbolOrCode ? `${symbolOrCode} ${formattedAmount}` : formattedAmount;
};
